import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {
  mofList,
  muniFolders,
  ordenanzasList,
  decretosList,
  cuisList,
  rasList,
  directivasList,
  organigramaList,
  otrosList,
  p_participativo_2025_List,
  presupuesto_2025_List,
  resoluciones_alcaldia_2024_List,
  resoluciones_alcaldia_2025_List,
  resolucionesFolders,
  rofList,
  transferencia_de_partidasList,
  tupaList,
  audiencia_publica_2026_List,
  rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026_List,
} from './utils/getDocuments';

// Layout
import MainLayout from './layouts/MainLayout';
// Home
import Home from './pages/home/Home';
// Municipality
import Municipality from './pages/municipality/Municipality';
import About from './pages/municipality/About';
import MainOffice from './pages/municipality/MainOffice';
import DistrictCreation from './pages/municipality/DistrictCreation';
import MissionAndVision from './pages/municipality/MissionAndVision';
import InstrumentsList from './pages/municipality/management_instruments/InstrumentsList';
import ManagementInstruments from './pages/municipality/management_instruments/ManagementInstruments';
// Services
import Services from './pages/services/Services';
import PartsTable from './pages/services/PartsTable';
import ServiceList from './pages/services/ServiceList';
import ComplaintsBook from './pages/services/ComplaintsBook';
// District
import District from './pages/district/District';
// News
import News from './pages/news/News';
// Galeria
import Galeria from './pages/galeria/Galeria';
// Contact
import Contact from './pages/contact/Contact';
// 404
import NotFound from './pages/404/NotFound';
// Privacy Policy
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
// Documents
import Folders from './components/muni/Folders';
import FoldersTable from './components/muni/FoldersTable';
import Documents from './components/muni/Documents';
// Convocatorias
import ConvocatoriaCAS from './pages/convocatoria/ConvocatoriaCAS';

function App() {
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  console.log('Maintenance Mode:', isMaintenanceMode);
  if (isMaintenanceMode) {
    return (
      <div className='App'>
        <MainLayout>
          <Routes>
            <Route path='*' element={<NotFound />} />
          </Routes>
        </MainLayout>
      </div>
    );
  }

  return (
    <div className='App'>
      <MainLayout>
        <Toaster
          position='top-center'
          reverseOrder={false}
          toastOptions={{
            success: {
              duration: 3000,
            },
            error: {
              duration: 3000,
            },
          }}
        />
        <Routes>
          <Route index element={<Home />} />
          <Route path='municipalidad' element={<Municipality />}>
            <Route index element={<About />} />
            <Route path='sede-central' element={<MainOffice />} />
            <Route
              path='ley-de-creacion-distrital'
              element={<DistrictCreation />}
            />
            <Route path='mision-y-vision' element={<MissionAndVision />} />
            <Route
              path='instrumentos-de-gestion'
              element={<ManagementInstruments />}
            >
              <Route
                index
                element={
                  <InstrumentsList
                    Data={() => <Folders items={muniFolders} />}
                  />
                }
              />
              <Route
                path='mof'
                element={
                  <InstrumentsList
                    folder='MOF'
                    Data={() => <Documents title='MOF' items={mofList} />}
                  />
                }
              />
              <Route
                path='ordenanzas'
                element={
                  <InstrumentsList
                    folder='Ordenanzas'
                    Data={() => (
                      <Documents title='Ordenanzas' items={ordenanzasList} />
                    )}
                  />
                }
              />
              <Route
                path='decretos'
                element={
                  <InstrumentsList
                    folder='Decretos'
                    Data={() => (
                      <Documents title='Decretos' items={decretosList} />
                    )}
                  />
                }
              />
              <Route
                path='cuis'
                element={
                  <InstrumentsList
                    folder='CUIS'
                    Data={() => <Documents title='CUIS' items={cuisList} />}
                  />
                }
              />
              <Route
                path='ras'
                element={
                  <InstrumentsList
                    folder='RAS'
                    Data={() => <Documents title='RAS' items={rasList} />}
                  />
                }
              />
               <Route
                path='directivas'
                element={
                  <InstrumentsList
                    folder='DIRECTIVAS'
                    Data={() => <Documents title='DIRECTIVAS' items={directivasList} />}
                  />
                }
              />
              <Route
                path='organigrama'
                element={
                  <InstrumentsList
                    folder='Organigrama'
                    Data={() => (
                      <Documents title='Organigrama' items={organigramaList} />
                    )}
                  />
                }
              />
              <Route
                path='otros'
                element={
                  <InstrumentsList
                    folder='Otros'
                    Data={() => <Documents title='Otros' items={otrosList} />}
                  />
                }
              />
              <Route
                path='presupuesto-participativo-2025'
                element={
                  <InstrumentsList
                    folder='Presupuesto Participativo 2025'
                    Data={() => (
                      <Documents
                        title='Presupuesto Participativo 2025'
                        items={p_participativo_2025_List}
                      />
                    )}
                  />
                }
              />
              <Route
                path='presupuesto-2025'
                element={
                  <InstrumentsList
                    folder='Presupuesto 2025'
                    Data={() => (
                      <Documents
                        title='Presupuesto 2025'
                        items={presupuesto_2025_List}
                      />
                    )}
                  />
                }
              />
              <Route
                path='resoluciones'
                element={
                  <InstrumentsList
                    folder='Resoluciones'
                    Data={() => (
                      <FoldersTable
                        title='Resoluciones'
                        items={resolucionesFolders}
                      />
                    )}
                  />
                }
              />
              <Route
                path='resoluciones/2024'
                element={
                  <InstrumentsList
                    folder='Resoluciones de Alcaldía 2024'
                    Data={() => (
                      <Documents
                        title='Resoluciones de Alcaldía 2024'
                        items={resoluciones_alcaldia_2024_List}
                      />
                    )}
                  />
                }
              />
              <Route
                path='resoluciones/2025'
                element={
                  <InstrumentsList
                    folder='Resoluciones de Alcaldía 2025'
                    Data={() => (
                      <Documents
                        title='Resoluciones de Alcaldía 2025'
                        items={resoluciones_alcaldia_2025_List}
                      />
                    )}
                  />
                }
              />
              <Route
                path='rof'
                element={
                  <InstrumentsList
                    folder='ROF'
                    Data={() => <Documents title='ROF' items={rofList} />}
                  />
                }
              />
              <Route
                path='transferencia-de-partidas'
                element={
                  <InstrumentsList
                    folder='Transferencia de Partidas'
                    Data={() => (
                      <Documents
                        title='Transferencia de Partidas'
                        items={transferencia_de_partidasList}
                      />
                    )}
                  />
                }
              />
              <Route
                path='tupa'
                element={
                  <InstrumentsList
                    folder='TUPA'
                    Data={() => <Documents title='TUPA' items={tupaList} />}
                  />
                }
              />
              <Route
                path='rendicion-de-cuentas-y-transferencia-de-gestion-2023-2026'
                element={
                  <InstrumentsList
                    folder='Rendición de Cuentas y Transferencia de Gestión 2023-2026'
                    Data={() => (
                      <Documents
                        title='Rendición de Cuentas y Transferencia de Gestión 2023-2026'
                        items={rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026_List}
                      />
                    )}
                  />
                }
              />  
              <Route path='*' element={<NotFound />} />
            </Route>
            <Route path='*' element={<NotFound />} />
          </Route>
          <Route path='servicios' element={<Services />}>
            <Route index element={<ServiceList />} />
            <Route path='transparencia'>
              <Route
                path='audiencia-publica-rendicion-de-cuentas-2026'
                element={
                  <InstrumentsList
                    folder='Audiencia Pública Rendición de Cuentas 2026'
                    Data={() => (
                      <Documents
                        title='Audiencia Pública Rendición de Cuentas 2026'
                        subtitle='Cuentas claras gestión transparente'
                        items={audiencia_publica_2026_List}
                      />
                    )}
                  />
                }
              />
              <Route
                path='rendicion-de-cuentas-y-transferencia-de-gestion-2023-2026'
                element={
                  <InstrumentsList
                    folder='Rendición de Cuentas y Transferencia de Gestión 2023-2026'
                    Data={() => (
                      <Documents
                        title='Rendición de Cuentas y Transferencia de Gestión 2023-2026'
                        subtitle='Cuentas claras gestión transparente'
                        items={rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026_List}
                      />
                    )}
                  />
                }
              />
            </Route>
            <Route path='mesa-de-partes-virtual' element={<PartsTable />} />
            <Route path='libro-de-reclamaciones' element={<ComplaintsBook />} />
            <Route path='*' element={<NotFound />} />
          </Route>
          <Route path='distrito' element={<District />} />
          <Route path='convocatoria-cas' element={<ConvocatoriaCAS />} />
          <Route path='noticias' element={<News />} />
          <Route path='galeria' element={<Galeria />} />
          <Route path='contacto' element={<Contact />} />
          <Route path='politica-de-privacidad' element={<PrivacyPolicy />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </MainLayout>
    </div>
  );
}

export default App;
